import { createMuiTheme, colors } from '@material-ui/core';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

import typography from './typography';


const breakpoints = createBreakpoints({});
const theme = createMuiTheme({
  breakpoints,
  palette: {
    background: {
      // dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: colors.blueGrey[900],
    },
    secondary: {
      main: '#111111'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  section: {
    paddingTop: '5rem',
  },
  overrides: {
    disableRipple: true, // No more ripple, on the whole application 💣!
    MuiTypography: {
      h1: {
        [breakpoints.down('xs')]: {
          fontSize: '2rem'
        }
      },
      h2: {
        [breakpoints.down('xs')]: {
          fontSize: '1.5rem'
        }
      },
      h3: {
        [breakpoints.down('xs')]: {
          fontSize: '1rem'
        }
      },
    }
  },
  shape: {
    // borderRadius: 0
  },
  // spacing: 10,
  typography
});

export default theme;
